/* ==========================================================
   Maison Atlas — Kit Conversion
   assets/ma-conversion.js
   1) Lecture des vidéos uniquement quand elles sont visibles
   2) Barre d'achat collante mobile (héritage)

   Session 3 (2026-08-21) — initAddToCart() a été supprimée.
   Elle interceptait tout formulaire [data-ma-add], ajoutait
   l'article en Ajax puis quittait la page :
       window.location.href = form.querySelector('input[name="return_to"]').value || '/cart';
   Ni tiroir, ni événement, ni pastille mise à jour — et une
   TypeError si le champ return_to manquait, dont le catch
   resoumettait le formulaire : le même article était ajouté
   deux fois.
   Les trois formulaires concernés passent désormais par
   product-form-component, le mécanisme natif de Horizon.
   ========================================================== */
(function () {
  if (window.__maConversionLoaded) return;
  window.__maConversionLoaded = true;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  /* ---------- 1. Vidéos ---------- */
  function initVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('[data-ma-reel] video'));
    if (!videos.length) return;
    videos.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.controls = false;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('preload', 'none');
      v.setAttribute('tabindex', '-1');
      v.setAttribute('aria-hidden', 'true');
    });
    if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (video.getAttribute('preload') === 'none') {
            video.setAttribute('preload', 'auto');
            video.load();
          }
          var playing = video.play();
          if (playing && playing.catch) { playing.catch(function () {}); }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: 0.55 });
    videos.forEach(function (v) { observer.observe(v); });
  }
  /* ---------- 2. Barre collante ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-ma-stickybar]');
    var hero = document.querySelector('.ma-hero');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.15 });
    observer.observe(hero);
  }
  function init() { initVideos(); initStickyBar(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
